module.exports = __webpack_public_path__ + "static/media/lungdis_help2019.5d4b7557.png";